import { Button } from '../../../Button';
import { ModalFullPage, ModalFullPageActions, ModalFullPageContent, ModalFullPageTitle } from '../../../ModalFullPage';


export type AddInsuranceMobileFormWrapperType = {
  title: string;
  cancel?: () => void;
  back?: () => void;
  next?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  loading?: boolean;
};

export const AddInsuranceMobileFormWrapper: React.FC<AddInsuranceMobileFormWrapperType> = ({
  title,
  cancel,
  back,
  next,
  nextLabel,
  nextDisabled,
  loading,
  children
}) => {

  return (
    <ModalFullPage onClose={cancel} closeIcon open transition>
      <ModalFullPageTitle displayMobileOnlyStyles>
        {title}
      </ModalFullPageTitle>
      <ModalFullPageContent>
        {children}
      </ModalFullPageContent>
      <ModalFullPageActions displayMobileOnlyStyles>
        {back && (
          <Button
            onClick={back}
            size="large"
            variant="outlined"
          >
            Back
          </Button>
        )}
        <Button
          loading={loading}
          disabled={nextDisabled}
          onClick={next}
          size="large"
          variant="contained"
          color="secondary"
        >
          {nextLabel ?? 'Next'}
        </Button>
      </ModalFullPageActions>
    </ModalFullPage>
  );
};
